import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import getUrl from "../../../functions/getUrl";
import { IPostPreview } from "../../../interfaces/posts";
import { useLocation, useNavigate } from "react-router-dom";
import sem_foto from "../../../assets/images/sem-foto.jpg";
import formatarData from "../../../functions/formatDate";

const PreviewItem: React.FC<{post: IPostPreview}> = ({post}) => {

    const navigate = useNavigate();

    const location = useLocation();

    const isWhite = location.pathname === "/";

    let url;

    if(post.filename)
        url = getUrl("posts", post.filename);
    else
        url = sem_foto;
    console.log('url', url);

    const isMobile = useMediaQuery("(max-width:768px)");
    
    return (
        <Box component="li" style={{ width: isMobile ? "95vw": "20vw", margin: "0 auto",  listStyle: "none"}}>
            <Box component="div" style={{ 
                height: '100%', 
                backgroundColor: "transparent", 
                boxShadow:"none", 
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            }} >

                <Box component="div" style={{
                backgroundImage: `url(${url})`,
                backgroundPosition:"top",
                backgroundSize:"cover",
                width:"100%",
                aspectRatio:"1/1",
            
                }}>
                    <Box component="ul" style={
                        {
                            display: "flex",
                            flexFlow: "row wrap",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "0.5em",
                            padding: "1em"
                        }
                    }>
                        {
                            post.tags.map( tag => (
                                <Typography sx={{ bgcolor: "#004387",color: "#fff", borderRadius: "1em", padding: "0.3em 0.5em"}}>{tag}</Typography>
                            ))
                        }
                    </Box>
                    <Typography sx={{
                        textAlign: "left",
                        textShadow: "0 0 3px #000", 
                        color: "#fff", 
                        fontWeight: 600, 
                        padding: "0 1em" 
                    }}>{formatarData(new Date(post.createdAt))}</Typography>
                </Box>
                <Box flex="1" display="flex" flexDirection="column" justifyContent="space-between">
                    <Box >
                        <Typography variant="h6" textAlign="left" color={isWhite ? "white" : 'warning'}>{post.title}</Typography>
                        <Typography variant="body2" textAlign="left" color={isWhite ? "white" : ''}>
                            {post.preview}
                        </Typography>  
                    </Box>
                    <Button
                        size="small"
                        color="warning"
                        onClick={() => navigate(`/blog/post/${post.slug}`)}
                        sx={isWhite ? 
                            {
                                color: "white", // Cor do texto branco
                                "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.1)", // Leve fundo branco translúcido ao passar o mouse
                                },
                            } : {}
                        }
                    >
                    Leia Mais
                    </Button>

                </Box>
                </Box>
        </Box>
    )
}
export default PreviewItem;
